var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCancelWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 18,
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5043_8959)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 17.4384C3.8165 17.4384 0 13.6219 0 8.93835C0 4.25485 3.8165 0.438354 8.5 0.438354C13.1835 0.438354 17 4.25485 17 8.93835C17 13.6219 13.1835 17.4384 8.5 17.4384ZM8.5 2.13835C4.7515 2.13835 1.7 5.18985 1.7 8.93835C1.7 12.6869 4.7515 15.7384 8.5 15.7384C12.2485 15.7384 15.3 12.6869 15.3 8.93835C15.3 5.18985 12.2485 2.13835 8.5 2.13835Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.05 12.3384C10.829 12.3384 10.6165 12.2534 10.4465 12.0919L5.34653 6.99186C5.01503 6.66036 5.01503 6.12486 5.34653 5.79336C5.67803 5.46186 6.21353 5.46186 6.54503 5.79336L11.645 10.8934C11.9765 11.2249 11.9765 11.7604 11.645 12.0919C11.475 12.2619 11.2625 12.3384 11.0415 12.3384H11.05Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.95003 12.3384C5.72903 12.3384 5.51653 12.2534 5.34653 12.0919C5.01503 11.7604 5.01503 11.2249 5.34653 10.8934L10.4465 5.79336C10.778 5.46186 11.3135 5.46186 11.645 5.79336C11.9765 6.12486 11.9765 6.66036 11.645 6.99186L6.54503 12.0919C6.37503 12.2619 6.16253 12.3384 5.94153 12.3384H5.95003Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5043_8959"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  fill: "white",
  transform: "translate(0 0.438354)"
})))));
export default SvgIconCancelWallet;